import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-edit, document, cloud, sync"><path d="M4.75 8.75V2.75H12.75L19.25 9.25V21.25H9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.5V9.25H18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.24414 21.0002L3.74414 19.5002L3.74414 13.2568C3.74414 12.4284 4.41571 11.7568 5.24414 11.7568C6.07257 11.7568 6.74414 12.4284 6.74414 13.2568L6.74414 19.5002L5.24414 21.0002Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileEdit;
